<template>
    <div class="tfa-setup">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div class="card">
              <div class="card-header">Verifikasi Two-Factor Authentication (2FA)</div>
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <p class="">Silahkan Scan Kode QR di bawah untuk menggunakan Two-Factor Authentication</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <!-- aktifkan jika dari lokal -->
                    <img class="img-fluid " width="200" height="200" :src="$http.options.base + qr_code_url" alt="QR CODE"> 
                     <!-- aktifkan jika menggunakan toba -->
                     <!-- <img class="img-fluid" :src="'data:image/png;base64,' + qr_code_url" alt="QR CODE" width="200" height="200"> -->
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col">
                    <form @submit.prevent="confirm">
                      <div class="form-group">
                        <label for="otp_verification">Masukkan OTP dari aplikasi Google Authenticator</label>
                        <input
                          type="number"
                          v-model="otp_verification"
                          class="form-control"
                          id="otp_verification"
                          placeholder="Masukkan OTP"
                          required
                          autofocus
                        />
                      </div>
                      <div class="form-group">
                        <button type="submit" class="btn btn-primary">
                          Confirm
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        qr_code_url: '',
        otp_verification: '',
        errorMessage: null
      }
    },
    mounted () {
      this.fetchQrCode()
    },
    methods: {
      // aktifkan jika menggunakan toba
      // fetchQrCode () {
      //   this.$http.get('tfa/view-file/' + this.$store.state.tfa.qr_code_url).then((response) => {
      //     if (response.data.base64) {
      //       this.qr_code_url = response.data.base64
      //     }
      //   })
      // },
      // aktifkan jika menggunakan local
      fetchQrCode () {
        this.$http.get('tfa/view-file-local/pj/' + localStorage.getItem('USER_NAME')).then((response) => {
          if (response.data) {
            this.qr_code_url = response.data.qr_code_url
          }
        })
      },
      confirm () {
        var data = {
          USER_NAME: localStorage.getItem('USER_NAME'),
          password: localStorage.getItem('password'),
          otp_verification: this.otp_verification
        }
        this.$http.post('tfa/confirm/pj', data).then((response) => {
          if (response.data.error) {
            this.errorMessage = response.data.error
          } else {
            this.$store.dispatch('auth/attempt', response.data.token).then(() => {
              localStorage.removeItem('USER_NAME')
              localStorage.removeItem('password')
              let nextUrl = this.$route.query.redirect == null ? '/dashboard' : this.$route.query.redirect
              this.$router.push(nextUrl)
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
.tfa-setup {
  margin-top: 50px;
}

.card-header {
  text-align: center;
  font-weight: bold;
}

.card-body {
  padding: 20px;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.alert {
  margin-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/Tfasetup.vue?c1f6e63a